<template>
  <div class="modal fade createNewModal" id="AddElementModal" tabindex="-1" ref="addElementModalRef" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
          <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
        </div>
        <div class="modal-body">
          <Form ref="elementForm" @submit="addElement" :validation-schema="elementSchema">
            <div class="row">
              <!-- Nom -->
              <div class="col-md-6 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Nom<span class="text-danger">*</span>
                  </label>
                  <Field name="nom" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le nom" />
                  <ErrorMessage name="nom" class="text-danger" />
                </div>
              </div>

              <!-- Prénom -->
              <div class="col-md-6 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Prénoms <span class="text-danger">*</span>
                  </label>
                  <Field name="prenom" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer les prénoms du parent" />
                  <ErrorMessage name="prenom" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Numéro NPI <span class="text-danger">*</span>
                  </label>
                  <Field name="npi" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le numéro NPI" />
                  <ErrorMessage name="npi" class="text-danger" />
                </div>
              </div>

              <!-- Sexe -->
              <div class="col-md-6 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Sexe <span class="text-danger">*</span>
                  </label>
                  <Field name="sexe" v-slot="{ field }">
                    <Multiselect :searchable="true"
                      :options="[{ label: 'Masculin', value: 'Masculin' }, { label: 'Féminin', value: 'Féminin' }]"
                      v-model="field.value" v-bind="field" placeholder="Sélectionner le sexe" />
                  </Field>
                  <ErrorMessage name="sexe" class="text-danger" />
                </div>
              </div>


              <!-- Email -->
              <div class="col-md-6 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-1">
                    Email <span class="text-danger">*</span>
                  </label>
                  <Field name="email" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer l'email du parent" />
                  <ErrorMessage name="email" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date de naissance
                  </label>
                  <Field name="dateNaissance" type="date" :max="currentDate"
                    class="form-control shadow-none fs-md-15 text-black" />
                </div>
                <ErrorMessage name="dateNaissance" class="text-danger" />
              </div>

              <div class="col-md-6 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Téléphone 1 <span class="text-danger">*</span>
                  </label>
                  <Field name="telephone1" v-slot="{ field }">
                    <vue-tel-input placeholder="Entrer le numéro de téléphone" v-model="field.value" v-bind="field"
                      defaultCountry="BJ" mode="international" @validate="validate"
                      class="shadow-none fs-md-15 text-black py-2" />
                  </Field>
                  <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correct</div>
                  <ErrorMessage name="telephone1" class="text-danger" />
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Téléphone 2
                  </label>
                  <Field name="telephone2" v-slot="{ field }">
                    <vue-tel-input placeholder="Entrer le second numéro de téléphone" v-model="field.value"
                      v-bind="field" defaultCountry="BJ" mode="international" @validate="validate"
                      class="shadow-none fs-md-15 text-black py-2" />
                  </Field>
                  <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correct</div>
                  <ErrorMessage name="telephone2" class="text-danger" />
                </div>
              </div>

              <!-- Profession -->
              <div class="col-md-6 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Profession
                  </label>
                  <Field name="profession" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Saisir la profession" />
                  <ErrorMessage name="profession" class="text-danger" />
                </div>
              </div>

              <!-- Lien de parenté -->
              <div class="col-md-6 mb-3">
                <div class="modern-select-group">
                  <label class="modern-label">
                    <i class="fas fa-users me-2"></i>
                    Lien de parenté
                  </label>
                  <Field name="lienParente" v-slot="{ field }">
                    <Multiselect v-model="field.value" v-bind="field"
                      :options="[{ label: 'Père', value: 'Père' }, { label: 'Mère', value: 'Mère' }, { label: 'Tuteur', value: 'Tuteur' }]"
                      :multiple="false" :searchable="false" placeholder="Choisir le lien de parenté" label="label"
                      track-by="value" class="modern-multiselect" />
                  </Field>
                  <ErrorMessage name="lienParente" class="text-danger" />
                </div>
              </div>

              <!-- Commune -->
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Commune <span class="text-danger">*</span>
                  </label>
                  <Field name="commune" v-model="commune" v-slot="{ field }">
                    <Multiselect :options="communeOptions" @change="communeChange($event)" :searchable="true"
                      track-by="label" label="label" v-model="selectedCommune" v-bind="field"
                      placeholder="Sélectionner la commune" />
                  </Field>
                  <ErrorMessage name="commune" class="text-danger" />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Quartier <span class="text-danger">*</span>
                  </label>
                  <Field name="quartier" v-model="quartier" v-slot="{ field }">
                    <Multiselect :options="quartierOptions" :searchable="true" track-by="label" label="label"
                      v-model="selectedQuartier" v-bind="field" noOptionsText="Sélectionner d'abord une commune"
                      placeholder="Sélectionner le quartier" />
                  </Field>
                  <ErrorMessage name="quartier" class="text-danger" />
                </div>
              </div>

              <!-- Adresse -->
              <div class="col-md-4 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Adresse
                  </label>
                  <Field name="adresse" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Saisir l'adresse" />
                  <ErrorMessage name="adresse" class="text-danger" />
                </div>
              </div>
            </div>

            <button
              class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
              type="submit">
              {{ btntext }}
            </button>
          </Form>
        </div>

        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"
          @click="resetValue()"></button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import Multiselect from '@vueform/multiselect';
import ApiService from '../../services/ApiService';
import { Parent } from '../../models/Parent';
import { error, success, hideModal } from '../../utils/utils';
import { VueTelInput } from 'vue3-tel-input';
import 'vue3-tel-input/dist/vue3-tel-input.css';
import { countries } from '../../components/Inscription/countries';

export default defineComponent({
  name: "AddParentModal",
  components: { Form, Field, ErrorMessage, Multiselect, VueTelInput },
  props: {
    selectedInscription: { type: Object, default: null }
  },
  setup(props, { emit }) {
    const currentDate = ref(new Date().toISOString().split('T')[0]);
    const validPhone = ref<boolean>(false);
    const telephone1 = ref();
    const telephone2 = ref();
    const codepay = ref();
    const nationalnumlber = ref();
    const numberPhone = ref();
    const countriesRef = ref(countries);
    const quartierOptions = ref([]);
    const communeOptions = ref([]);
    const elementForm = ref<any>(null);
    const addElementModalRef = ref<null | HTMLElement>(null);
    const initialValues = ref<any>({});
    const isUPDATE = ref(false);
    const title = ref('Ajouter un parent');
    const btntext = ref('Ajouter');



    const elementSchema = Yup.object().shape({
      nom: Yup.string().required('Le nom du parent est obligatoire'),
      prenom: Yup.string().required('Le prénom du parent est obligatoire'),
      npi: Yup.string()
        .matches(/^\d{10}$/, "La saisie doit avoir exactement 10 chiffres")
        .required("Le numéro NPI est obligatoire"),
      sexe: Yup.string().required('Le sexe est obligatoire'),
      adresse: Yup.string().notRequired(),
      telephone1: Yup.string().required('Le téléphone du parent est obligatoire'),
      telephone2: Yup.string().notRequired(),
      email: Yup.string().email('Email invalide').required('L\'email du parent est obligatoire'),
      lienParente: Yup.string().required('Le lien de parenté est obligatoire'),
      profession: Yup.string().nullable().notRequired(),
      quartier: Yup.string().required('Le quartier est obligatoire'),
      dateNaissance: Yup.date()
        .required('La date de naissance est obligatoire')
        .max(new Date(), 'La date de naissance ne peut pas être dans le futur')
        .test(
          'age-minimum',
          'Le parent doit avoir au moins 18 ans',
          function (value) {
            if (!value) return false;
            const today = new Date();
            const birthDate = new Date(value);
            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
              age--;
            }
            return age >= 18;
          }
        ),
    });


    function validate(phoneObject) {
      validPhone.value = phoneObject.valid;
      if (phoneObject.valid == true) {
        telephone1.value = phoneObject.number;
        telephone2.value = phoneObject.number;
        codepay.value = phoneObject.countryCallingCode;
        nationalnumlber.value = phoneObject.nationalNumber;
        numberPhone.value = phoneObject.nationalNumber;

      } else {
        telephone1.value = "";
        telephone2.value = "";
        codepay.value = "";
        nationalnumlber.value = "";
        numberPhone.value = "";
      }
    }


    const selectedCommune = ref();
    const selectedQuartier = ref();

    // Charger les communes au départ
    const fetchCommunes = async () => {
      const { data } = await ApiService.get("/communes");
      communeOptions.value = data.data.data.map((item: any) => ({
        value: item.id,
        label: item.libelle,
      }));
    };

    // Charger les quartiers selon la commune choisie
    function communeChange(value) {
      if (value) {
        quartierOptions.value = [];
        selectedQuartier.value = null;
        ApiService.get("/communes/quartiers/" + value)
          .then(({ data }) => {
            const donnees = data.data;
            quartierOptions.value = donnees.map((quartier: any) => ({
              label: quartier.libelle,
              value: quartier.id,
            }));
          })
          .catch(({ response }) => {
            console.error(response.data.message);
          });
      } else {
        quartierOptions.value = [];
        selectedQuartier.value = null;
      }
    }

    const addElement = async (values: any) => {
      const payload = {
        ...values,
        quartierId: selectedQuartier.value?.value ?? null,
        communeId: selectedCommune.value?.value ?? null,
        parentetudiant: props.selectedInscription
          ? { etudiantId: props.selectedInscription.etudiant.id }
          : undefined
      };

      ApiService.post("/parents", payload)
        .then(({ data }) => {
          if (data.code === 201) {
            success(data.message);
            resetValue();
            hideModal(addElementModalRef.value);
            emit('refresh');
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

    const resetValue = () => {
      selectedQuartier.value = null;
      selectedCommune.value = null;
      elementForm.value?.resetForm();
      isUPDATE.value = false;
    };

    onMounted(() => {
      fetchCommunes();
      resetValue();
    });

    return {
      elementForm,
      addElementModalRef,
      selectedQuartier,
      selectedCommune,
      quartierOptions,
      communeOptions,
      elementSchema,
      addElement,
      resetValue,
      communeChange, validPhone,
      title,
      btntext, validate, countries: countriesRef,

    };
  }
});
</script>
